import { FC, PropsWithChildren, useCallback, useMemo, useState } from "react";

import { Form } from "antd";

import { SpinnerPreliquidation } from "../../components/SpinnerPreliquidation"; 

import { GenericDataFormContext } from "./GenericDataFormContext";

import { GenerateNewPreliquidationServiceResponse, GetSummaryQuotesServiceResponse, LOADING_SAVED_PRELIQUIDATIONS_STATES, PreLiquidationStep, QUOTES_TYPE } from "../../interfaces";
import PreLiquidationService from "../../../../../../shared/services/collection/preliquidation";

import { ListQuotaItemDetail } from "../../../Steps/StepTwo/interfaces";


export const GenericDataFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const [ canShowSpinner, setCanShowSpinner ] = useState<boolean>(false);
  const [ currentStep, setCurrentStep ] = useState<number>(PreLiquidationStep.ONE);
  const [ canShowConfirmIssue, setCanShowConfirmIssue ] = useState<boolean>(false);
  const [ preliquidationInfo, setPreliquidationInfo ] = useState<GenerateNewPreliquidationServiceResponse>();

  const [ loadingSavedPreliquidation, setLoadingSavedPreliquidation ] = useState<boolean>(false);
  const [ selectedQuotas, setSelectedQuotas ] = useState<GetSummaryQuotesServiceResponse>();
  const [listQuota, setListQuota] = useState<Array<ListQuotaItemDetail>>();

  const [ preliquidationInitialForm ] = Form.useForm<{ hasAutomaticDebit: string }>();
  const [ preliquidationTotalValue, setPreliquidationTotalValue ] = useState<string>('0'); // todo: hay que cambiar esto...

  const [loadPreliquidationState, setLoadPreliquidationState] = useState<LOADING_SAVED_PRELIQUIDATIONS_STATES>();

  const getListOfSelectedQuotas = useCallback(async () => {
    setCanShowSpinner(true);
    try {
      const response = await PreLiquidationService.getSummaryQuotes({
        numeroPreliquidacion: preliquidationInfo?.numeroPreliquidacion!,
        tipo: QUOTES_TYPE.MARKED,
      });

      if (response.data) {

        const transformedData = response.data.cuotas.map((item) => {
          const key = String(Math.random());

          return {
            key,
            branchQuota: item.rama,
            policyQuota: item.poliza,
            endorsementQuota: item.suplemento,
            quotaQuota: item.numero,
            subQuotaQuota: item.subCuota,
            dueQuota: item.vencimiento,
            insuredQuota: item.asegurado,
            subtotalQuota: item.importePesos,
          };
        });

        setListQuota(transformedData);

        setSelectedQuotas(response.data);
      };
    } catch (error) {} finally {
      setCanShowSpinner(false);
    };
  }, [
    setSelectedQuotas,
    preliquidationInfo,
    setListQuota,
  ]);

  const values = useMemo(() => ({
    canShowSpinner,
    setCanShowSpinner,
    currentStep, 
    setCurrentStep,
    canShowConfirmIssue,
    setCanShowConfirmIssue,
    preliquidationInfo,
    setPreliquidationInfo,
    preliquidationInitialForm,
    preliquidationTotalValue,
    setPreliquidationTotalValue,
    loadingSavedPreliquidation, 
    setLoadingSavedPreliquidation,
    selectedQuotas, 
    setSelectedQuotas,
    loadPreliquidationState, 
    setLoadPreliquidationState,
    getListOfSelectedQuotas,
    listQuota,
  }), [
    canShowSpinner,
    setCanShowSpinner,
    currentStep, 
    setCurrentStep,
    canShowConfirmIssue,
    setCanShowConfirmIssue,
    preliquidationInfo,
    setPreliquidationInfo,
    preliquidationInitialForm,
    preliquidationTotalValue,
    setPreliquidationTotalValue,
    loadingSavedPreliquidation, 
    setLoadingSavedPreliquidation,
    selectedQuotas, 
    setSelectedQuotas,
    loadPreliquidationState, 
    setLoadPreliquidationState,
    getListOfSelectedQuotas,
    listQuota
  ]);

  return (
    <GenericDataFormContext.Provider value={ values }>
      <SpinnerPreliquidation>
        { children }
      </SpinnerPreliquidation>
    </GenericDataFormContext.Provider>
  )
}